import { render, staticRenderFns } from "./QnaItemsListCard.vue?vue&type=template&id=05519740"
import script from "./QnaItemsListCard.vue?vue&type=script&lang=ts"
export * from "./QnaItemsListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports